import { ProductDetail } from '@/models/ProductDetail'
import strings from '@/assets/strings.json'

export class PdfBuilder {
  private baseContent: any = {
    content: [
      {
        alignment: 'center',
        image: 'logo',
        width: 100,
        margin: [0, 20]
      },
      {
        alignment: 'center',
        text: this.pdfStrings.description1,
        style: 'descriptionText'
      },
      {
        alignment: 'center',
        text: this.pdfStrings.description2,
        style: 'descriptionText'
      },
      {
        alignment: 'center',
        text: this.pdfStrings.resume,
        style: 'boldText',
        margin: [0, 20]
      },
      {
        alignment: 'center',
        image: 'composition',
        // fit: [500, 500],
        fit: [200, 200],
      }
    ],
    images: {
    },
    styles: {
      descriptionText: {
        // fontSize: 14
        fontSize: 11
      },
      boldText: {
        // fontSize: 15,
        fontSize: 12,
        bold: true
      }
    }

  }

  constructor (products: ProductDetail[], totalAmount: string) {
    const productRows = []

    for (const product of products) {
      const imageAlias = 'product_' + product.id
      // this.baseContent.images[imageAlias] = product.image

      productRows.push([
        { image: imageAlias, height: 50, width: 50, border: [false, true, false, true] },
        {
          stack: [{ text: product.name }, { text: product.sku }],
          margin: [50, 10, 0, 0],
          border: [false, true, false, true],
          fontSize: 10
        },
        { text: product.formattedPrice, margin: [0, 15, 0, 0], border: [false, true, false, true], fontSize: 10 }
      ]);
    }

    const list: any[] = [{
      table: {
        headerRows: 0,
        widths: [50, '*', 60],
        heights: 50,
        body: productRows,
        dontBreakRows: true
      }
    },
    {
      alignment: 'right',
      text: this.pdfStrings.total + ' ' + totalAmount,
      bold: true,
      fontSize: 12,
      margin: [0, 20]
    }]

    this.baseContent.content.push(...list)
  }

  get pdfContent () {
    return this.baseContent
  }

  get pdfStrings () {
    return strings.Pdf
  }
}
